import React from 'react';

import { SettingItem } from 'crm/casino/pages/Settings/SettingItem';
import Settings from 'crm/casino/pages/Settings/Settings';

function PageSettingsList() {
    const availableSettings: SettingItem[] = [
        {
            name: 'Blog',
            icon: 'mdi mdi-file-image',
            path: 'page-settings/blog_image_visible',
            description: 'Show or hide images for blog',
        },
        {
            name: 'News',
            icon: 'mdi  mdi-file-image',
            path: 'page-settings/news_image_visible',
            description: 'Show or hide images for news',
        },
    ];

    return <Settings availableSettings={availableSettings} />;
}
export default PageSettingsList;
